import axios from 'axios'

export default {
  findAll: (page, pageSize) => axios.get(`/api/warnings`, {params : {page, pageSize}}).then(({data}) => data),
  setNote: (contractCode, note) => axios.patch(`/api/warnings/${contractCode}`, {note}),
  count: () => axios.get(`/api/warnings-count`).then(({data}) => data),
  patch: (contractCode, body) => axios.patch(`/api/warnings/${contractCode}`, body).then(({data}) => data),
  findByStatus: (status, page, pageSize) => axios.get(`/api/warnings`, { params: {status, page, pageSize} }).then(({data}) => data)
}
